var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('b-button',{staticClass:"mb-2",attrs:{"to":{ name: 'Home'},"variant":"primary"}},[_vm._v("Voltar")]),_vm._v(" "),_c('full-calendar',{attrs:{"events":_vm.getEvents,"config":_vm.config}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f3170ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Agenda.vue
// module id = 1036
// module chunks = 1